import { FC } from 'react'

import { Box } from '@mui/material'

import usePage from '../../../hooks/usePage'
import pageService from '../../../services/PageService'
import { OrganizationsList } from '../../features/organizations/components/OrganizationsList/OrganizationsList'

export const OrganizationsPage: FC = () => {
  usePage(pageService.getInternalPageWithId('internal-organizations'))

  return (
    <Box>
      <OrganizationsList />
    </Box>
  )
}
